import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc93df8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Go to Calls Review ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Automated Payment Transactions", -1))
const _hoisted_4 = { class: "row data center horizontal-center" }
const _hoisted_5 = { class: "text-center summary-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Payments", -1))
const _hoisted_7 = { class: "text-center summary-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Total Collected", -1))
const _hoisted_9 = { class: "row form-group" }
const _hoisted_10 = { class: "border" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "timezone-note" }, " ** All times are in Mountain Time (America/Denver). ", -1))
const _hoisted_12 = {
  key: 0,
  class: "table-loading"
}
const _hoisted_13 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "nowrap" }, "Payment Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "nowrap" }, "Payment Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Facility"),
    /*#__PURE__*/_createElementVNode("th", null, "Customer Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Customer ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "nowrap" }, "Amount Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Number")
  ])
], -1))
const _hoisted_15 = { class: "nowrap" }
const _hoisted_16 = { class: "nowrap" }
const _hoisted_17 = { class: "nowrap" }
const _hoisted_18 = {
  key: 0,
  class: "pagination"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]

import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "@/store";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";
import Filter from "@/components/Filter.vue";
import "@vueform/multiselect/themes/default.scss";

type ClientLite = {
  name: string;
  facilities: Array<{ facility_name: string }>;
};

type Option = { label: string; value: string | null; disabled: boolean };

type IvrPaymentItem = {
  id: number;
  transaction_uuid: string;
  facility_name: string;
  customer_name: string;
  customer_id: string;
  unit_number: string;
  amount_paid: string | number | null;
  phone_number: string;
  payment_backend: string;
  payment_timestamp: string;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const PAGE_SIZE = 25;
const SEARCH_DELAY_MS = 300;

const formSubmitting = ref(false);
const tableLoading = ref(false);
const errors = ref("");
const status = ref("loading");
const isInitialLoading = computed(() => status.value === "loading");
const payments = ref<IvrPaymentItem[]>([]);
const totalCount = ref(0);
const totalAmount = ref(0);
const page = ref(1);
const searchTerm = ref("");
const appliedSearch = ref("");
let searchTimer: ReturnType<typeof setTimeout> | undefined;
let latestRequest = 0;

const store = useStore();
const client = ref<ClientLite | null>(null);
const facilityOptions = ref<Option[]>([]);
const formFields = computed(() => store.clientPortalFormFields);
const dateOptions = ref([
  { text: "Current month", value: "current_month" },
  { text: "Last month", value: "last_month" },
  { text: "All year", value: "all_year" },
  { text: "Custom Dates", value: "custom" },
]);

const pageSize = PAGE_SIZE;
const pageStart = computed(() =>
  totalCount.value === 0 ? 0 : (page.value - 1) * pageSize + 1
);
const pageEnd = computed(() =>
  Math.min(page.value * pageSize, totalCount.value)
);

const DEFAULT_TIME_ZONE = "America/Denver";

const asInt = (n: number | string) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    Number(n) || 0
  );

function formatAmount(value: string | number | null | undefined) {
  const amount = Number(value);
  if (Number.isNaN(amount)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

function normalizeIsoToUTC(iso: string) {
  const s = iso.trim().replace(" ", "T");
  if (/([Zz]|[+-]\d{2}:?\d{2})$/.test(s)) return s;
  return `${s}Z`;
}

function parseIsoDate(iso: string) {
  if (!iso) return null;
  const normalized = normalizeIsoToUTC(iso);
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function resolveTimeZone(tz?: string | null) {
  const candidate = (tz || "").trim();
  if (!candidate) return DEFAULT_TIME_ZONE;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: candidate }).format(
      new Date()
    );
    return candidate;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

function getPart(parts: Intl.DateTimeFormatPart[], type: string) {
  return parts.find((p) => p.type === type)?.value ?? "";
}

function formatDateInTZ(iso: string, tz?: string | null) {
  const d = parseIsoDate(iso);
  if (!d) return "";
  const timeZone = resolveTimeZone(tz);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);
  const month = getPart(parts, "month");
  const day = getPart(parts, "day");
  const year = getPart(parts, "year");
  return `${month}-${day}-${year}`;
}

function formatTimeInTZ(iso: string, tz?: string | null, showTZ = true) {
  const d = parseIsoDate(iso);
  if (!d) return "";
  const timeZone = resolveTimeZone(tz);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...(showTZ ? { timeZoneName: "short" } : {}),
  }).formatToParts(d);
  const hour = getPart(parts, "hour");
  const minute = getPart(parts, "minute");
  const second = getPart(parts, "second");
  const dayPeriod = getPart(parts, "dayPeriod");
  const tzName = getPart(parts, "timeZoneName");
  const base = `${hour}:${minute}:${second} ${dayPeriod}`;
  return showTZ && tzName ? `${base} ${tzName}` : base;
}

function toYMD(d: string | Date | null | undefined) {
  return d instanceof Date ? d.toISOString().slice(0, 10) : d;
}

function buildPayload(formData?: typeof formFields.value) {
  const raw = formData ?? store.clientPortalFormFields;
  const payload = {
    ...raw,
    start_date: toYMD(raw.start_date),
    end_date: toYMD(raw.end_date),
    page: page.value,
    page_size: PAGE_SIZE,
    customer_name: appliedSearch.value,
  };

  if (!payload.selected_facilities?.length) {
    payload.selected_facilities =
      client.value?.facilities.map((f) => f.facility_name) || [];
  }

  return payload;
}

async function fetchPayments(formData?: typeof formFields.value) {
  errors.value = "";
  tableLoading.value = true;
  const requestId = ++latestRequest;

  const res = await api({
    url: `client/ivr_payments/`,
    method: "POST",
    json: buildPayload(formData),
  });

  if (requestId !== latestRequest) return;
  if (res.status === 200) {
    const body = (res.body || {}) as {
      count?: number | string;
      total_amount?: number | string;
      results?: IvrPaymentItem[];
    };
    totalCount.value = Number(body.count ?? 0);
    totalAmount.value = Number(body.total_amount ?? 0);
    payments.value = Array.isArray(body.results) ? body.results : [];
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
  }

  tableLoading.value = false;
}

async function getUserInfo() {
  status.value = "loading";
  errors.value = "";
  const response = await api({ url: `client/` });
  if (response.status === 200) {
    const body = response.body as ClientLite[] | undefined;
    client.value = body?.[0] ?? null;

    facilityOptions.value = [
      { label: "All Facilities", value: null, disabled: true },
      ...(client.value?.facilities ?? []).map((f) => ({
        label: f.facility_name,
        value: f.facility_name,
        disabled: false,
      })),
    ];
    await fetchPayments();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
  }
  status.value = "loaded";
}

async function submitForm(formData?: typeof formFields.value) {
  formSubmitting.value = true;
  if (formData) store.setClientPortalFormFields(formData);
  page.value = 1;
  await fetchPayments(formData);
  formSubmitting.value = false;
}

function handleFilterSubmit(fd: typeof formFields.value) {
  submitForm(fd);
}

watch(searchTerm, (term) => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    appliedSearch.value = term.trim();
    page.value = 1;
    fetchPayments();
  }, SEARCH_DELAY_MS);
});

async function goToPage(nextPage: number) {
  if (nextPage < 1) return;
  page.value = nextPage;
  await fetchPayments();
}

onMounted(() => getUserInfo());

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errors.value)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 0,
          variant: "danger",
          class: "js-form-error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(errors.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isInitialLoading))
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 1,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (client.value && !_unref(isInitialLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: { name: 'CallsReview' },
            class: "btn btn-text back-link"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("h1", null, _toDisplayString(client.value.name), 1),
          _createVNode(Filter, {
            "facility-options": facilityOptions.value,
            "date-options": dateOptions.value,
            "initial-form-fields": _unref(formFields),
            "form-submitting": formSubmitting.value,
            onSubmit: handleFilterSubmit
          }, null, 8, ["facility-options", "date-options", "initial-form-fields", "form-submitting"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("h3", null, _toDisplayString(asInt(totalCount.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("h3", null, _toDisplayString(formatAmount(totalAmount.value)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
              type: "text",
              style: {"max-width":"840px"},
              placeholder: "Search by Customer Name"
            }, null, 512), [
              [_vModelText, searchTerm.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (tableLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(BaseSpinner, { preset: "large" })
                ]))
              : (!payments.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, " No payment transactions found for the selected facilities and date range. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("table", null, [
                      _hoisted_14,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payments.value, (payment) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: payment.id
                          }, [
                            _createElementVNode("td", _hoisted_15, _toDisplayString(formatDateInTZ(payment.payment_timestamp)), 1),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(formatTimeInTZ(payment.payment_timestamp, undefined, false)), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.facility_name), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.customer_name || "—"), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.customer_id || "—"), 1),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(formatAmount(payment.amount_paid)), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.phone_number || "—"), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.unit_number || "—"), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    (totalCount.value > _unref(pageSize))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("button", {
                            class: "btn",
                            disabled: page.value <= 1,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value - 1)))
                          }, " Previous ", 8, _hoisted_19),
                          _createElementVNode("span", null, " Showing " + _toDisplayString(_unref(pageStart)) + "-" + _toDisplayString(_unref(pageEnd)) + " of " + _toDisplayString(asInt(totalCount.value)), 1),
                          _createElementVNode("button", {
                            class: "btn",
                            disabled: _unref(pageEnd) >= totalCount.value,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value + 1)))
                          }, " Next ", 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})